(function () {
  if (window.__batchigDiscoveryPopinInstalled) return;
  window.__batchigDiscoveryPopinInstalled = true;

  const root = window.Shopify?.routes?.root || '/';

  async function addVariant(variantId) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  function dispatchThemeCartUpdate(delta) {
    // même event que le thème
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: delta, source: 'product-form-component' } },
      })
    );
  }

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  document.addEventListener('click', async (event) => {
    const close = event.target.closest('[data-batchig-popin-close]');
    if (close) {
      close.closest('[data-batchig-popin]')?.remove();
      return;
    }

    const btn = event.target.closest('.js-batchig-discovery-add');
    if (!btn) return;

    event.preventDefault();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.style.pointerEvents = 'none';

    try {
      await addVariant(variantId);
      dispatchThemeCartUpdate(1);
      openDrawer();
    } catch (e) {
      console.error('[Batchig popin]', e);
    } finally {
      btn.classList.remove('is-loading');
      btn.style.pointerEvents = '';
    }
  });
})();
